import { useContext } from "react";
import { Store } from "../Store";
import { Helmet } from "react-helmet-async";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import MessageBox from "../components/MessageBox";
import ListGroup from "react-bootstrap/esm/ListGroup";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/esm/Card";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function CartScreen() {
    const { state, dispatch: ctxDispatch } = useContext(Store);
    const navigate=useNavigate();
    const {
        cart: { cartItems },
    } = state;

    const updateCardHandler=async(item, quantity)=>{
        const {data}= await axios.get(`/api/products/${item._id}`);

        if (data.countInStock < quantity) {
            window.alert('Sorry. Product is out of stock');
            return;
        }
                  
        ctxDispatch({type:'CART_ADD_ITEM',payload:{...item,quantity}});
    }

    const removeItemHandler=(item)=>{
        ctxDispatch({type:'CART_REMOVE_ITEM',payload:item});
    }

    const checkoutHandler=()=>{
        navigate('/signin?redirect=/shipping');   //判断是否signin 如果是的话就redirect到shipping page
    }

    return (
        <div>
            <Helmet>
                <title>Shopping Cart</title>
            </Helmet>
            <h1>Shopping Cart</h1>
            <Row>
                <Col md={8}>
                    {cartItems.length === 0 ? (
                        <MessageBox>
                            Cart is empty. <Link to="/"> Go Shopping</Link>
                        </MessageBox>
                    ) :
                        (
                            <ListGroup>
                                {cartItems.map((item) => (
                                    <ListGroup.Item key={item._id}>
                                        <Row className="align-items-center">
                                            <Col md={4}>
                                                <img
                                                    src={item.image}
                                                    alt={item.name}
                                                    className="img-fluid rounded img-thumbnail"
                                                ></img>{' '}
                                                <Link to={`/product/${item.slug}`}>{item.name}</Link>
                                            </Col>

                                            <Col md={3}>
                                                <Button 
                                                variant="light" 
                                                disabled={item.quantity === 1}
                                                onClick={()=>updateCardHandler(item,item.quantity-1)}
                                                >
                                                    <i className="fas fa-minus-circle"></i>
                                                </Button>{' '}

                                                <span>{item.quantity}</span>{' '}

                                                <Button 
                                                variant="light" 
                                                disabled={item.quantity === item.countInStock}
                                                onClick={()=>updateCardHandler(item,item.quantity+1)}
                                                >
                                                    <i className="fas fa-plus-circle"></i>
                                                </Button>{' '}
                                            </Col>
                                            <Col md={3}> ${item.price}</Col>

                                            <Col>
                                                <Button 
                                                variant="light"
                                                onClick={()=>removeItemHandler(item)}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )
                    }
                </Col>
                <Col md={4}>
                    <Card>
                        <Card.Body>
                            <ListGroup variant="flush">
                                <ListGroup.Item>
                                    <h3>
                                        Total ({cartItems.reduce((a, c) => a + c.quantity, 0)}{' '} items) :
                                        ${cartItems.reduce((a, c) => a + c.price * c.quantity, 0)}
                                    </h3>
                                </ListGroup.Item>

                                <ListGroup.Item>
                                    <div className="d-grid">
                                        <Button
                                            type="button"
                                            variant="primary"
                                            disabled={cartItems.length === 0}
                                            onClick={checkoutHandler}
                                        >
                                            Proceed to Checkout
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}